import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SentimentAnalysisModule } from '../sentiment-analysis.module';
import type {
  DashboardStats,
  RatingOverview,
} from '../../../services/sentiment-analysis-stats/sentiment-analysis-stats.service';
import type { SentimentFilterValue, ViewModeValue } from './theme-distribution-widget/theme-distribution-widget.component';

@Component({
  selector: 'app-sentiment-analysis-overview-home',
  standalone: true,
  imports: [CommonModule, SentimentAnalysisModule],
  templateUrl: './sentiment-analysis-overview-home.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['../sentiment-analysis-home/sentiment-analysis.layout.scss'],
})
export class SentimentAnalysisOverviewHomeComponent {
  @Input({ required: true }) stats!: DashboardStats | null;
  @Input({ required: true }) actionableComments!: number;
  @Input({ required: true }) sentimentData!: {
    positive: { count: number; percentage: number };
    neutral: { count: number; percentage: number };
    negative: { count: number; percentage: number };
  };
  @Input({ required: true }) npsScore!: number;
  @Input({ required: true }) sentimentScore!: number;
  @Input() ratingOverview: RatingOverview | null | undefined = null;

  @Input({ required: true }) sentimentFilter!: SentimentFilterValue;
  @Output() sentimentFilterChange = new EventEmitter<SentimentFilterValue>();

  @Input({ required: true }) viewMode!: ViewModeValue;
  @Output() viewModeChange = new EventEmitter<ViewModeValue>();

  onSentimentFilter(next: SentimentFilterValue): void {
    this.sentimentFilterChange.emit(next);
  }

  onViewMode(next: ViewModeValue): void {
    this.viewModeChange.emit(next);
  }
}
